import { BehaviorSubject } from 'rxjs';

export class FliInEditModeService {
    private fliInEditMode = new BehaviorSubject<string | null>(null);

    fliInEditMode$ = this.fliInEditMode.asObservable();

    enterFliEditMode(fliName: string): void {
        this.fliInEditMode.next(fliName);
    }

    exitFliEditMode(): void {
        this.fliInEditMode.next(null);
    }
}
